var extra_length = 0;
var extra_height = $('.sb_header_left').closest('.shopify-section').prevAll('.shopify-section');
extra_height.each(function (index,item) {
  if(index >= index-2) {
    extra_length = extra_length + $(item).height();
  }
});

function toggleStickyProductSlider() {
  var sb_header_left = $('.sb_header .sb_header_left');
  var sb_header_right = $('.sb_header .sb_header_right');
  if ($(window).width() > 1200 ) {
    var sb_header_right_top = sb_header_right.offset().top - $('#header').height();
    var stop_pos = 0;
    if($('.sb_header .sb_header_right .header_tabs_wrapper.desktop .header_tabs_buttons:last-child .vtd_btn_fluid.vtd_button_secondary').hasClass('selected')) {
      if ($('.sb_header .sb_header_right .header_tabs_wrapper.desktop .header_tabs_buttons:last-child .hedaer_tab_texts .opened').position().top) {
        stop_pos = $('.sb_header .sb_header_right .header_tabs_wrapper.desktop .header_tabs_buttons:last-child .hedaer_tab_texts .opened').height() + 65;
      }
    }
    var stop_position = $('.sb_header .sb_header_right .header_tabs_buttons:last-child .vtd_btn_fluid.vtd_button_secondary').position().top + stop_pos;
    var extra_height = 160;
    if ($(window).width() >= 1600 ) {
      extra_height = 100;
    }
    stop_position = stop_position - ($('.sb_header .sb_header_slide_container.header-picker').height() + $('.sb_header .sb_header_slider').height() + $('.sb_header .sb_header_right .header_tabs_buttons:last-child .vtd_btn_fluid.vtd_button_secondary').height() + extra_height);
    if (stop_position > 0) {
      if ( extra_length <= 48) {
        sb_header_left.css("top",(stop_position - 46) + "px");
      } else {
        sb_header_left.css("top",(stop_position - 46 - extra_length ) + "px");
      }
      $('.fancybox__container .sb_header .sb_header_left').css('top',0);
    } else {
      sb_header_left.css("top", '0px');
    }

    var scroll = $(window).scrollTop().valueOf();
    if (scroll > sb_header_right_top && scroll < stop_position) {
      if ($(window).width() >= 1600 ) {
        sb_header_right.css('margin-left',sb_header_left.width()+65)
      } else {
        sb_header_right.css('margin-left',sb_header_left.width())
      }
      sb_header_left.addClass('fixed');
      sb_header_left.css('top', $('#header').height()+'px');
    } else if(scroll >= stop_position) {
      if (sb_header_left.hasClass('fixed')) {
        var margin_top = $(window).scrollTop();
        if (margin_top > stop_position ) {
          margin_top = stop_position;
        }
        if ( extra_length <= 48) {
          sb_header_left.css("top",(margin_top - 46) + "px");
        } else {
          sb_header_left.css("top",(margin_top - 46 - extra_length ) + "px");
        }
        sb_header_right.css('margin-left',0);
        sb_header_left.removeClass('fixed');
      }
    } else if (scroll <= sb_header_right_top) {
      sb_header_right.css('margin-left',0);
      sb_header_left.removeClass('fixed');
      sb_header_left.css('top','0px');
    }
  } else {
    sb_header_right.css('margin-left',0)
    sb_header_left.removeClass('fixed');
    sb_header_left.css('top','0px');
  }
}

$(window).scroll(function() {
  toggleStickyProductSlider();
});

$(window).resize(function() {
  toggleStickyProductSlider();
});
$(window).load(function() {
  toggleStickyProductSlider();
});

$('.sb_header_right .header_tab_desktop .header_tabs_buttons .vtd_btn_fluid').click(function(e) {
  toggleStickyProductSlider();
});
